import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Notes from '../../components/Notes';
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments,updateFaqsNotesDocuments,deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectNotes } from '../../store/selectors/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch,clearSearch } from '../../store/actions/search'

class AssetNotes extends Component {
  componentDidMount(){
    const { asset,clearSearch,onFetchFaqsNotesDocuments} = this.props;
    clearSearch()
    // onFetchFaqsNotesDocuments(asset.id);
  }
  onSaveNote = note => {
    const {  onSaveFaqsNotesDocuments,onUpdateFaqsNotesDocuments  } = this.props;
    let utcTime = ''
    if(note.appointment){

   
 
    let date = new Date(note.appointment.date);
    let time = new Date(note.appointment.time)
    let hours = time.getHours();
    let minutes =time.getMinutes();
    date.setHours(hours);
    date.setMinutes(minutes)
 
    // utcTime = date.toUTCString()
     utcTime = date
  }

    if(note.id){
      let data = {
        ItemId: this.props.asset.id,
        "id": note.id,
        Name: 'NOTES',
        Type: 'NOTES',
        ItemType: 'Asset',
        "data": JSON.stringify(note).toString(),
        "UserId": this.props.user.id,
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,
      }
      if(note.appointment){
        data.ReminderDate = utcTime
      }
      onUpdateFaqsNotesDocuments(data)

    }else{
      note = { ...note,'author':{
        "id": this.props.user.id,
        "firstName": this.props.user.firstname,
        "lastName": this.props.user.lastname
      },'createdAt': new Date()}
      let data = {
        ItemId: this.props.asset.id,
        Name: 'NOTES',
        Type: 'NOTES',
        ItemType: 'Asset',
        Data: JSON.stringify(note).toString(),
        UserId: this.props.user.id,
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,
      }

      if(note.appointment){
        data.ReminderDate = utcTime
      }
      
     onSaveFaqsNotesDocuments(data)

    }


  }

  render() {
    const { notes, asset,onDeleteFaqsNotesDocuments,setSearch } = this.props;
    return (
      <Notes
        from={'assets'}
        breadcrumb={asset.name}
        notes={notes}
        onSaveNote={this.onSaveNote}
        onDeleteNote={ notes => onDeleteFaqsNotesDocuments({...notes,Type:'NOTES'})}
        onSearch={e => setSearch({ notes: e.target.value.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  notes: selectNotes(state),
  user: selectAuthenticatedUser(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
  onUpdateFaqsNotesDocuments:updateFaqsNotesDocuments,
  onDeleteFaqsNotesDocuments:deleteFaqsNotesDocuments,
  setSearch,
  clearSearch
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AssetNotes);
